/* ============================================================================
   SHOPPING STREET — "Quiet Atelier" theme behaviour
   Cart AJAX, drawers, search, product gallery, variants, sort, infinite scroll,
   and motion. Money shown as rounded KWD per brand decision.
   ============================================================================ */
(function(){
const R = window.SSroutes || {};
const $  = (s,r)=> (r||document).querySelector(s);
const $$ = (s,r)=> [...(r||document).querySelectorAll(s)];

/* ---- money: Shopify stores prices in ×100 cents (e.g. 3500 = 35.000 KWD);
   the shop's money format fakes the 3rd decimal. Show rounded whole KWD. ---- */
function money(cents){ return Math.round(cents/100) + ' KWD'; }

/* ---- drawers / overlay ---- */
function openDrawer(id){ $('#scrim').classList.add('show'); const el=$('#'+id); if(el) el.classList.add('show'); document.body.style.overflow='hidden'; }
function closeAll(){ $$('.drawer,.scrim,.search-overlay').forEach(e=>e.classList.remove('show')); document.body.style.overflow=''; }
function openSearch(){ const s=$('#search'); if(!s) return; s.classList.add('show'); document.body.style.overflow='hidden'; setTimeout(()=>{const i=$('#searchInput'); if(i) i.focus();},120); }

/* ---- cart ---- */
async function refreshCart(open){
  try{
    const res = await fetch(R.cart + '.js', {headers:{'Accept':'application/json'}});
    const cart = await res.json();
    renderCart(cart);
    if(open) openDrawer('cart');
  }catch(e){ console.warn('cart fetch failed', e); }
}
function renderCart(cart){
  const cc=$('#cc'); if(cc){ cc.textContent=cart.item_count; cc.hidden = cart.item_count===0; }
  const body=$('#cartBody'), foot=$('#cartFoot');
  if(!body) return;
  if(cart.item_count===0){ body.innerHTML='<p class="muted" style="font-size:13px">'+(window.SSstr?SSstr.empty:'Your bag is empty.')+'</p>'; if(foot) foot.style.display='none'; return; }
  body.innerHTML = cart.items.map(i=>`
    <div class="cart-line" data-key="${i.key}">
      <a href="${i.url}"><img src="${i.featured_image && i.featured_image.url ? i.featured_image.url : ''}" alt=""></a>
      <div class="meta">
        <div>${i.product_title}</div>
        ${i.variant_title && i.variant_title!=='Default Title' ? '<div class="nm">'+i.variant_title+'</div>' : '<div class="nm">'+(window.SSstr&&SSstr.variantDefault||'18kt Gold Plated')+'</div>'}
        <div class="pr">${money(i.final_line_price)}</div>
        <span class="qty"><button data-qty="-1" aria-label="−">−</button><span>${i.quantity}</span><button data-qty="1" aria-label="+">+</button></span>
        <span class="rm" data-remove>${window.SSstr&&SSstr.remove||'Remove'}</span>
      </div>
    </div>`).join('');
  if(foot){ $('#subtotal').textContent=money(cart.items_subtotal_price); foot.style.display='block'; }
}
async function addToCart(variantId, qty){
  if(!variantId) return;
  try{
    await fetch(R.add + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:variantId, quantity:qty||1})});
    $$('.qa.show').forEach(q=>q.classList.remove('show'));
    refreshCart(true);
  }catch(e){ console.warn('add failed', e); }
}
async function changeLine(key, quantity){
  try{
    const res = await fetch(R.change + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity})});
    renderCart(await res.json());
  }catch(e){ console.warn('change failed', e); }
}

/* ---- delegated clicks ---- */
document.addEventListener('click', e=>{
  const open = e.target.closest('[data-open]'); if(open){ e.preventDefault(); open.dataset.open==='search'?openSearch():openDrawer(open.dataset.open); return; }
  if(e.target.closest('[data-close]')){ closeAll(); $('#search')&&$('#search').classList.remove('show'); document.body.style.overflow=''; return; }

  const qaT = e.target.closest('[data-qa-toggle]');
  if(qaT){ const qa=qaT.closest('.card__add').querySelector('.qa'); $$('.qa.show').forEach(q=>{if(q!==qa)q.classList.remove('show')}); qa.classList.toggle('show'); return; }

  const add = e.target.closest('[data-add],[data-pdp-add]');
  if(add && !add.disabled){ e.preventDefault(); addToCart(add.dataset.variantId, 1); return; }

  // cart qty / remove
  const line = e.target.closest('.cart-line');
  if(line){
    const key=line.dataset.key;
    const q=e.target.closest('[data-qty]');
    if(q){ const cur=parseInt(line.querySelector('.qty span').textContent); changeLine(key, Math.max(0,cur+parseInt(q.dataset.qty))); return; }
    if(e.target.closest('[data-remove]')){ changeLine(key,0); return; }
  }

  // accordions
  const ah=e.target.closest('.acc__h, .footer .fcol h5');
  if(ah){ if(ah.closest('.footer') && innerWidth>760) return; ah.parentElement.classList.toggle('open'); return; }
});
document.addEventListener('keydown', e=>{ if(e.key==='Escape'){ closeAll(); const s=$('#search'); if(s)s.classList.remove('show'); document.body.style.overflow=''; } });

/* ---- predictive search ---- */
function initSearch(){
  const input=$('#searchInput'); if(!input || !R.predictive) return;
  let t; const out=$('#psearch');
  input.addEventListener('input', ()=>{
    clearTimeout(t); const q=input.value.trim();
    if(q.length<2){ if(out) out.innerHTML=''; return; }
    t=setTimeout(async()=>{
      try{
        const res=await fetch(`${R.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=`);
        const data=await res.json();
        const items=(data.resources&&data.resources.results&&data.resources.results.products)||[];
        if(out) out.innerHTML=items.map(p=>`<a href="${p.url}"><img src="${p.featured_image?p.featured_image.url:''}" alt=""><span><span class="t">${p.title}</span><br><span class="p">${p.price?money(p.price):''}</span></span></a>`).join('') || '<p class="muted" style="font-size:13px;padding:8px">'+(window.SSstr&&SSstr.noMatches||'No matches yet.')+'</p>';
      }catch(e){}
    },220);
  });
}

/* ---- smooth image zoom (PDP gallery) — hover-follow on desktop, tap-to-zoom on touch ---- */
function initZoom(stage){
  const canHover = matchMedia('(hover:hover) and (pointer:fine)').matches;
  $$('img',stage).forEach(img=>{
    const origin=e=>{
      const r=img.getBoundingClientRect(); const pt=(e.touches&&e.touches[0])||e;
      const x=Math.max(0,Math.min(100,((pt.clientX-r.left)/r.width)*100));
      const y=Math.max(0,Math.min(100,((pt.clientY-r.top)/r.height)*100));
      img.style.transformOrigin=x+'% '+y+'%';
    };
    const reset=()=>{ img.classList.remove('zoomed'); img.style.transformOrigin='center'; };
    if(canHover){
      img.addEventListener('mouseenter',e=>{ origin(e); img.classList.add('zoomed'); });
      img.addEventListener('mousemove',origin);
      img.addEventListener('mouseleave',reset);
    }else{
      img.addEventListener('click',e=>{ img.classList.contains('zoomed') ? reset() : (origin(e), img.classList.add('zoomed')); });
      img.addEventListener('touchmove',e=>{ if(img.classList.contains('zoomed')){ e.preventDefault(); origin(e); } },{passive:false});
    }
  });
}

/* ---- product gallery + variants (PDP) ---- */
function initPDP(){
  const pdp=$('.pdp'); if(!pdp) return;
  const stage=$('#shots'), thumbs=$('#thumbs');
  if(stage){
    initZoom(stage);
    if(thumbs){
      $$('img',thumbs).forEach(t=>t.addEventListener('click',()=>{ stage.children[+t.dataset.i].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'}); }));
      stage.addEventListener('scroll',()=>{ const i=Math.round(stage.scrollLeft/stage.clientWidth); $$('img',thumbs).forEach((t,k)=>t.classList.toggle('active',k===i)); });
    }
  }
  // variants
  const data=$('#pdp-data'); if(!data) return;
  const variants=JSON.parse(data.textContent);
  let current=variants.find(v=>v.available)||variants[0];
  const priceEl=$('#pdp-price'), sprice=$('#sprice'), optname=$('#optname'), atc=$$('[data-pdp-add]'), waEl=$('#wa-order');
  function paint(){
    if(priceEl) priceEl.innerHTML = (current.compare>current.price?`<span class="was">${money(current.compare)}</span>`:'') + money(current.price);
    if(sprice) sprice.textContent = money(current.price);
    if(optname) optname.textContent = current.title;
    atc.forEach(b=>{ b.dataset.variantId=current.id; b.disabled=!current.available; b.textContent = current.available ? (window.SSstr?SSstr.add:'Add to Bag') : (window.SSstr?SSstr.sold:'Sold out'); });
    if(waEl){
      const vt = (current.title && current.title!=='Default Title') ? ' — '+current.title : '';
      const msg = `${window.SSstr&&SSstr.waHello||"Hello! I'd like to order this piece:"}\n${waEl.dataset.waTitle}${vt}\n${money(current.price)}\n${waEl.dataset.waUrl}`;
      waEl.href = `https://wa.me/${waEl.dataset.waPhone}?text=${encodeURIComponent(msg)}`;
    }
  }
  $$('.swatch').forEach(sw=>sw.addEventListener('click',()=>{
    if(sw.classList.contains('out')) return;
    const v=variants.find(x=>x.id==sw.dataset.id); if(!v) return; current=v;
    $$('.swatch').forEach(x=>x.classList.remove('active')); sw.classList.add('active'); paint();
  }));
  paint();
}

/* ---- collection: sort + infinite scroll via Section Rendering API ---- */
function initCollection(){
  const grid=$('#cgrid'); if(!grid) return;
  const loader=$('#loader'); if(!loader) return;
  let nextUrl=loader.dataset.next || '';
  let loading=false;
  const io=new IntersectionObserver(async es=>{
    if(!es[0].isIntersecting || loading || !nextUrl) return;
    loading=true;
    try{
      const res=await fetch(nextUrl);
      const text=await res.text();
      const doc=new DOMParser().parseFromString(text,'text/html');
      const newGrid=doc.querySelector('#cgrid');
      const newLoader=doc.querySelector('#loader');
      if(newGrid){ [...newGrid.children].forEach(c=>{c.classList.add('fade-in'); grid.appendChild(c);}); }
      nextUrl = newLoader ? (newLoader.dataset.next||'') : '';
      if(!nextUrl){ loader.textContent = loader.dataset.end || 'You’ve reached the end'; io.disconnect(); }
    }catch(e){ console.warn(e); }
    loading=false;
  },{rootMargin:'700px'});
  if(nextUrl) io.observe(loader); else loader.style.display='none';
}

/* ---- motion ---- */
const io=new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){
  if(e.target.classList.contains('stagger')){ [...e.target.children].forEach((c,i)=>c.style.transitionDelay=(i*70)+'ms'); }
  e.target.classList.add('in'); io.unobserve(e.target);
}}),{threshold:.12});

/* ---- boot ---- */
function boot(){
  // header scroll (homepage transparent hero only)
  const header=$('#header'); const hasHero=!!$('.hero');
  if(header && hasHero) addEventListener('scroll',()=>header.classList.toggle('scrolled',scrollY>80),{passive:true});
  // hero slideshow
  const slides=$$('.hero__slide');
  if(slides.length>1){ let i=0; setInterval(()=>{ slides[i].classList.remove('active'); i=(i+1)%slides.length; slides[i].classList.add('active'); }, 2500); }
  // hero intro — start the word-parting only once the serif webfont is ready, so the
  // words never swap font mid-animation (FOUT). Safety timeout guarantees it always plays.
  if($('.hero__intro')){
    let started=false; const go=()=>{ if(!started){ started=true; document.documentElement.classList.add('hero-go'); } };
    if(document.fonts && document.fonts.load){
      document.fonts.load('700 1em "Cormorant Garamond"').then(()=>document.fonts.ready).then(go).catch(go);
      setTimeout(go, 1400);
    } else { go(); }
  }
  // back to top
  const tt=$('#totop'); if(tt){ tt.addEventListener('click',()=>scrollTo({top:0,behavior:'smooth'})); addEventListener('scroll',()=>tt.classList.toggle('show',scrollY>700),{passive:true}); }
  // motion
  $$('.reveal,.stagger').forEach(el=>io.observe(el));
  initSearch(); initPDP(); initCollection(); refreshCart(false);
}
window.SS={ addToCart, openDrawer, openSearch, closeAll, observe(){ $$('.reveal:not(.in),.stagger:not(.in)').forEach(el=>io.observe(el)); } };
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
